import { BuildingSide } from "building-types/settings/roofTypes";
import type { Face } from "geom/brep";
import { DIST_EPSILON } from "geom/core";
import { planeEvalDir, planeProject } from "geom/plane";
import type { Vec2 } from "geom/vec2";
import { vec2Dot, vec2Normalize } from "geom/vec2";
import { vec3Normalize } from "geom/vec3";

function faceSlopeDir2(face: Face): Vec2 {
  const [uu, uv] = planeProject(face.plane, face.plane.originX, face.plane.originY, face.plane.originZ + 1);

  let [slopex, slopey, slopez] = planeEvalDir(face.plane, uu, uv);
  [slopex, slopey, slopez] = vec3Normalize(slopex, slopey, slopez);

  return vec2Normalize(slopex, slopey);
}

export function roofFaceBuildingSideWithFlips(face: Face, flipX: boolean, flipY: boolean): BuildingSide {
  const [slopex, slopey] = faceSlopeDir2(face);

  const xdot = vec2Dot(1, 0, slopex, slopey);

  if (Math.abs(xdot - 1) < DIST_EPSILON) {
    return flipX ? BuildingSide.RIGHT : BuildingSide.LEFT;
  } else if (Math.abs(xdot + 1) < DIST_EPSILON) {
    return flipX ? BuildingSide.LEFT : BuildingSide.RIGHT;
  }

  const ydot = vec2Dot(0, 1, slopex, slopey);

  if (Math.abs(ydot - 1) < DIST_EPSILON) {
    return flipY ? BuildingSide.BACK : BuildingSide.FRONT;
  } else if (Math.abs(ydot + 1) < DIST_EPSILON) {
    return flipY ? BuildingSide.FRONT : BuildingSide.BACK;
  }

  return BuildingSide.DIAGONAL;
}

export function roofFaceBuildingSide(face: Face, mirror: boolean | undefined): BuildingSide {
  return roofFaceBuildingSideWithFlips(face, mirror ?? false, false);
}
